import { Tv } from 'lucide-react';

/**
 * BroadcasterBadges — small brand-coloured pill row showing which UK TV
 * channels are carrying the match. Resolved on the backend
 * (services/broadcasters.py) with admin overrides. Renders nothing when empty.
 *
 * `size` = "sm" (compact, for match rows) | "md" (match detail header).
 */
const BroadcasterBadges = ({ broadcasters, size = 'md' }) => {
  if (!broadcasters || broadcasters.length === 0) return null;
  const sm = size === 'sm';
  return (
    <div className="flex items-center gap-1 flex-wrap" data-testid="broadcaster-badges">
      <Tv className={`${sm ? 'w-2.5 h-2.5' : 'w-3 h-3'} text-zinc-500 shrink-0`} />
      {broadcasters.map((b) => (
        <span
          key={b.slug}
          style={{ backgroundColor: b.color || 'rgba(255,255,255,0.1)', color: b.text || '#fff' }}
          className={`inline-flex items-center rounded font-extrabold tracking-wide uppercase ${
            sm ? 'px-1.5 py-[1px] text-[8px]' : 'px-2 py-0.5 text-[9px]'
          }`}
          data-testid={`broadcaster-${b.slug}`}
        >
          {b.name}
        </span>
      ))}
    </div>
  );
};

export default BroadcasterBadges;
